<template>
    <div>
        <div class="title__rank">
            <span class="helper__tooltip purple icon__title">
                <span v-html="t.title_ba_mansion"></span>
                <span
                    class="helper__tooltip--text"
                    v-html="t.tooltip_builderall_mansion_v4"
                ></span>
            </span>
            <span 
                class="helper__tooltip mansion__video"
                data-toggle="modal" 
                data-target="#modal-mansion-video">
            </span>
        </div>
        <div class="mansion__bonus card-v4">
            <div class="graphics">
                <section>
                    <div class="loading__out">
                        <div class="loading__bar">
                            <div class="bar" :style="{ width: firstGraphic + '%' }"></div>
                        </div>
                        <span>{{onlyValueFirst}}</span>
                    </div>
                    <h3>50 {{t.mansion_title_1}}</h3>
                </section>
                <section>
                    <div class="loading__out">
                        <div class="loading__bar">
                            <div class="bar" :style="{ width: secondGraphic + '%' }"></div>
                        </div>
                        <span>{{onlyValueSecond}}</span>
                    </div>
                    <h3>50 {{t.mansion_title_2}}</h3>
                </section>
                <section>
                    <div class="loading__out">
                        <div class="loading__bar">
                            <div class="bar" :style="{ width: thirdGraphic + '%' }"></div>
                        </div>
                        <span>{{onlyValueThird}}</span>
                    </div>
                    <h3>200 {{t.mansion_title_3}}</h3>
                </section>
            </div>
        </div>


        <div class="modal fade" id="modal-mansion-video" tabindex="-1" role="dialog" aria-labelledby="modal-mansion-video">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="container__youtube">
                            <iframe src="https://player.vimeo.com/video/362029553?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "mansion-bonus",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.ba_mansion,
            onlyValueFirst: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_first,
            firstGraphic: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_first,
            onlyValueSecond: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_second,
            secondGraphic: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_second,
            onlyValueThird: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_third,
            thirdGraphic: this.$parent.view.dashboard_values_v3.mansion_bonus
                .graphic_third
        };
    },
    methods: {},
    mounted() {
        if (this.firstGraphic > 50) this.firstGraphic = 50;
        if (this.secondGraphic > 50) this.secondGraphic = 50;
        if (this.thirdGraphic > 200) this.thirdGraphic = 200;

        this.firstGraphic = (this.firstGraphic * 100) / 50;
        this.secondGraphic = (this.secondGraphic * 100) / 50;
        this.thirdGraphic = (this.thirdGraphic * 100) / 200;
    }
};
</script>
<style scoped lang="scss">
.helper__tooltip--text {
    text-align: left;
    top: 31px;
    left: unset;
    right: -47px;
}
.icon__title {
    margin-right: 40px;
}
.mansion__video {
    width: 55px;
    margin-top: 9px;
    &::after {
        content: '';
        background-repeat: no-repeat;
        width: 18px;
        height: 17px;
        position: absolute;
        top: 6px;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        right: 15px;
        background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIuODAzNSIgY3k9IjEyLjUiIHI9IjEyLjUiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS4zMDM0NyA2VjIwTDIwLjMwMzUgMTNMOS4zMDM0NyA2WiIgZmlsbD0iIzdFMUFGRCIvPgo8L3N2Zz4=);
    }
}
.mansion__bonus {
    .graphics {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        margin: 2rem 0 0 0;
        .loading__out {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .loading__bar {
                height: 12px;
                border-radius: 15px;
                margin: 0.4rem 0;
                border: 1px solid #c6c6c6;
                width: 80%;
                .bar {
                    border-radius: 15px;
                    height: 10px;
                    background: var(--theme-color-primary);
                    transition: 0.1s all ease;
                }
            }
            span {
                color: var(--theme-color-primary);
                font-weight: bold;
            }
        }
        h3 {
            text-align: center;
            color: #707070;
        }
    }
}
@media (max-width: 850px) {
    .mansion__bonus .graphics {
        grid-template-columns: auto;
    }
}
.helper__tooltip:after {
    top: 0;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/mansionBonus.vue